import {observable, action, runInAction} from 'mobx'
import {getUserInfo, logout} from '@apis'

const LOCAL_BROKER_ID = 'local_broker_id'

class Store {
  @observable userInfo = null

  @action setUserInfo = info => {
    this.userInfo = info
  }

  @action queryUserInfo = async () => {
    const res = await getUserInfo()
    if (res) {
      runInAction(() => {
        this.setUserInfo(res)
        localStorage.setItem(LOCAL_BROKER_ID, res.brokerId)
      })
    }
  }

  @action userLogout = async () => {
    await logout()
    runInAction(() => {
      this.setUserInfo(null)
      localStorage.setItem(LOCAL_BROKER_ID, null)
    })
  }
}

export default new Store()